module.exports = __webpack_public_path__ + "static/media/driver-s-license.b5f9ef67.svg";